import { SelectionCardWebElementBase } from './SelectionCardWebElementBase';

/**
 * The component WebElement for [oj-c-selection-card](../../jsdocs/oj-c.SelectionCard.html).
 * Do not instantiate this class directly, instead, use
 * [findSelectionCard](../functions/findSelectionCard.html).
 */
export class SelectionCardWebElement extends SelectionCardWebElementBase {
  // Put overrides here
}
